import { useGetQuery, useLazyGetQuery, usePostMutation } from "slices/api";
import { MENU_ITEMS } from "tagTypes";

export const useGetMenuItemsQuery = (query = {}, isFireSafety = false,isUtilityTunnel) =>
  useGetQuery({
    endpoint: isFireSafety ? "firesafety-menu":isUtilityTunnel?"/uta-card-issuance-menu" : "/menu",
    query,
    tags: [MENU_ITEMS],
  });

export const useGetMenuDocumentParentQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/menu/parents",
    query,
    tags: [MENU_ITEMS],
  });

export const useLazyGetMenuItemsQuery = () => {
  const [getMenuItems, data] = useLazyGetQuery();
  const menuitems = async (query = {}) =>
    await getMenuItems(
      {
        endpoint: "/menu",
        query,
        tags: [MENU_ITEMS],
      },
      true
    ).unwrap();
  return [menuitems, data];
};

export const usePostMenuItemsMutation = () => {
  const [applicationType, data] = usePostMutation();
  const addApplicationType = async (payload, query = {}) =>
    await applicationType({
      endpoint: "/menu",
      query,
      payload: payload || {},
      toastMessage: "Content updated successfully",
      tags: [MENU_ITEMS],
    }).unwrap();

  return [addApplicationType, data];
};

export const useGetMenuDetailsById = (id) =>
  useGetQuery({
    endpoint: `/menu/${id}`,
    tags: [MENU_ITEMS],
  });

export const useLazyGetMenuDetailsById = () => {
  const [getMenuDetails, menuItems] = useLazyGetQuery();
  const getMenuDetailsById = async (id) =>
    await getMenuDetails({
      endpoint: `/menu/${id}`,
      tags: [MENU_ITEMS],
    }).unwrap();

  return [getMenuDetailsById, menuItems];
};

export const useGetMenuContentQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/menu/content-type",
    query,
    tags: [MENU_ITEMS],
  });

export const useGetMenuDetailsByContentType = () => {
  const [getMenuDetailsByContentType, menuItems] = useLazyGetQuery();
  const getMenuDetails = async (query = {}) =>
    await getMenuDetailsByContentType({
      endpoint: "/menu/content-type",
      query,
      tags: [MENU_ITEMS],
    }).unwrap();

  return [getMenuDetails, menuItems];
};
